<template>
  <div class="v2-container">
    <div class="v2-hero">
      <div class="v2-hero-left">
        <div class="v2-hero-avatar">
          <div class="svg-container v2-hero-avatar__svg-container">
            <!-- <div
              id="js-hero-avatar__svg-container-bg"
              class="v2-hero-avatar__svg-container-bg"
            ></div> -->
            <div class="v2-hero-avatar__svg-container-img"></div>
            <SVGAvatar />
          </div>
        </div>
      </div>
      <div class="v2-hero-right">
        <div id="js-hero-typed" class="v2-hero-title">
          <span id="js-hero-title-src">
            <span>Larissa Angald</span>
          </span>
          <span id="js-hero-title"></span>
        </div>
        <div id="js-hero-descr" class="v2-hero-descr">
          <span>Front-end developer |</span>

          <div id="js-hero-descr-wrap" class="v2-hero-descr-wrap">
            <div>Vue.js</div>
            <div>Laravel</div>
            <div>HTML</div>
            <div>JavaScript</div>
            <div>Sass</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SVGAvatar from "@/assets/img/outline-avatar.svg?inline";
import Typed from "typed.js";
import { TweenMax, TimelineMax } from "gsap/TweenMax";
import "gsap/src/uncompressed/plugins/ScrollToPlugin";

export default {
  name: "V2Hero",
  components: { SVGAvatar },
  mounted() {
    this.initHeroTitleAnim();
    this.initHeroDescrAnim();
    this.initHeroBlocksAnim();
  },
  methods: {
    initHeroTitleAnim() {
      let typed = new Typed("#js-hero-title", {
        stringsElement: "#js-hero-title-src",
        typeSpeed: 90,
        startDelay: 3000,
        // showCursor: false,
        onComplete: (self) => {
          document.querySelector(
            "#js-hero-typed .typed-cursor"
          ).style.opacity = 0;
        },
      });
    },
    initHeroDescrAnim() {
      var exi = Expo.easeInOut;
      var ntl = document.querySelectorAll("#js-hero-descr-wrap div").length;
      var tl = new TimelineMax({ paused: true, repeat: -1 });
      tl.staggerFrom(
        "#js-hero-descr-wrap div:not(:first-child)",
        2,
        { y: "110%", ease: exi, yoyo: true },
        2,
        "a"
      );

      tl.staggerTo(
        "#js-hero-descr-wrap div",
        2,
        { y: "-110%", ease: exi, yoyo: true },
        2,
        "a"
      );

      tl.to(
        "#js-hero-descr-wrap div:first-child",
        0,
        { y: "100%", delay: 2 * (ntl - 1), yoyo: true },
        "a"
      );
      tl.to(
        "#js-hero-descr-wrap div:first-child",
        2,
        { y: "0%", delay: 2 * (ntl - 1), ease: exi, yoyo: true },
        "a"
      );

      tl.play();
    },
    initHeroBlocksAnim() {
      var opts = {
        y: 20,
        opacity: 0,
      };
      var tl = new TimelineMax()
        .from("#js-hero-typed", 1, opts)
        .from("#js-hero-descr", 1, opts, "+=1")
        .delay(3);

      var tl2 = new TimelineMax()
        .from("#js-hero-avatar__svg-container-bg", 1, {
          x: -50,
          opacity: 0,
          scale: 0.7,
        })
        .delay(3);
    },
  },
};
</script>
